import { render, staticRenderFns } from "./MgrupoprioridadForm.vue?vue&type=template&id=f16c2126"
import script from "./MgrupoprioridadForm.vue?vue&type=script&lang=js"
export * from "./MgrupoprioridadForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports